import {
  FieldSelect,
  FormField,
  FormGrid,
  ModalBody,
  ModalFoot,
} from '@dixa/lib-shared-habla';
import { Field, Form, InjectedFormProps, reduxForm } from 'redux-form';

import { FieldCategorizedMultiSelect } from 'fable/fieldCategorizedMultiSelect';
import {
  AutomationChannel,
  AutomationTrigger,
  AutomationTriggerHumanNames,
} from 'hocs';

import { FORM_NAME, validateEditFormStep2 } from '../utils/editAutomationForm';

import styles from './editAutomationForm.module.scss';
import type { EditAutomationModalFormValuesT } from './types';

type EditAutomationFormStep2ImplOwnProps = {
  handleCancel: () => void;
  handleFormSubmit: (
    values: EditAutomationModalFormValuesT,
  ) => Promise<void> | undefined;
  isCreating: boolean;
};

type InjectedProps = InjectedFormProps<
  EditAutomationModalFormValuesT,
  EditAutomationFormStep2ImplOwnProps
>;

type PropsT = EditAutomationFormStep2ImplOwnProps & InjectedProps;

const TriggerOptions = [
  {
    id: AutomationTrigger.CONVERSATION_ASSIGNED,
    name: AutomationTriggerHumanNames.CONVERSATION_ASSIGNED,
  },
  {
    id: AutomationTrigger.CONVERSATION_ABANDONED,
    name: AutomationTriggerHumanNames.CONVERSATION_ABANDONED,
  },
  {
    id: AutomationTrigger.CONVERSATION_CLOSED,
    name: AutomationTriggerHumanNames.CONVERSATION_CLOSED,
  },
  {
    id: AutomationTrigger.CONVERSATION_ADDED_TO_QUEUE,
    name: AutomationTriggerHumanNames.CONVERSATION_ADDED_TO_QUEUE,
  },
  {
    id: AutomationTrigger.MESSAGE_SEND_BY_AGENT,
    name: AutomationTriggerHumanNames.MESSAGE_SEND_BY_AGENT,
  },
  {
    id: AutomationTrigger.MESSAGE_SEND_BY_USER,
    name: AutomationTriggerHumanNames.MESSAGE_SEND_BY_USER,
  },
];

export const CategoryOptions = [
  {
    categoryName: 'Text',
    disabled: false,
    items: [
      {
        name: 'Email',
        value: AutomationChannel.EMAIL,
        icon: 'mail',
      },
      {
        name: 'Contact form',
        value: AutomationChannel.CONTACTFORM,
        icon: 'contact-form',
      },
    ],
  },
];

const EditAutomationFormStep2Impl = (props: PropsT): JSX.Element => {
  const { handleSubmit, handleCancel, submitting, isCreating, pristine } =
    props;

  return (
    <Form onSubmit={handleSubmit(props.handleFormSubmit)}>
      <ModalBody>
        <FormGrid>
          <FormField>
            <Field
              label="Select channels"
              name="channels"
              component={FieldCategorizedMultiSelect}
              required
              readOnly={!isCreating}
              className={styles.field}
              categoryOptions={CategoryOptions}
            />
          </FormField>
          <FormField>
            <Field
              label="Select a trigger"
              name="trigger"
              component={FieldSelect}
              placeholder="An action that will begin your automation"
              required
              disabled={!isCreating}
              items={TriggerOptions}
              className={styles.field}
            />
          </FormField>
        </FormGrid>
      </ModalBody>
      <ModalFoot
        cancelOnClick={handleCancel}
        cancelName="Cancel"
        confirmOnClick={handleSubmit(props.handleFormSubmit)}
        confirmName="Next"
        confirmProps={{
          isLoading: submitting,
          disabled: pristine || submitting,
        }}
      />
    </Form>
  );
};

export const EditAutomationFormStep2 = reduxForm<
  EditAutomationModalFormValuesT,
  EditAutomationFormStep2ImplOwnProps
>({
  form: FORM_NAME,
  enableReinitialize: false,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateEditFormStep2,
})(EditAutomationFormStep2Impl);
